export default "/images/vendor/flag-icon-css/flags/1x1/af.svg?867627c537fd298125324bc38d88de90";